import { isAxiosError } from 'axios'

import { api } from '@/api/client'
import {
  parseAuthCaptchaPayload,
} from '@/lib/auth-captcha'
import type { LoginResponse, MeResponse } from '@/types/api'

export {
  AuthCaptchaInvalidError,
  AuthCaptchaRequiredError,
} from '@/lib/auth-captcha'

export async function fetchAuthChallengeStatus() {
  const { data } = await api.get<{ success: boolean; data: unknown }>('/auth/challenge-status')
  return data.data
}

export async function loginRequest(
  login: string,
  password: string,
  recaptchaToken?: string | null,
) {
  try {
    const { data } = await api.post<LoginResponse>('/auth/login', {
      login,
      password,
      ...(recaptchaToken ? { recaptcha_token: recaptchaToken } : {}),
    })
    return data
  } catch (err) {
    if (isAxiosError(err) && err.response) {
      const captchaError = parseAuthCaptchaPayload(err.response.data, err.response.status)
      if (captchaError) throw captchaError
    }
    throw err
  }
}

export async function confirmLoginOtp(challenge: string, code: string) {
  const { data } = await api.post<LoginResponse>('/auth/login/otp', { challenge, code })
  return data
}

export async function meRequest() {
  const { data } = await api.get<MeResponse>('/auth/me')
  return data
}

export async function logoutRequest() {
  await api.post('/auth/logout')
}
